module.exports = __webpack_public_path__ + "static/media/condo.45f54241.svg";